<template>
    <div class="flex flex-col  w-full h-full">
        <div class=" w-full flex flex-col space-y-4">
            <div class="w-full flex flex-col space-y-2">
                <div class="">Username:</div>
                <!-- <input class="p-3 bg-gray-150 w-full border border-gray-300 rounded-md" required disabled type="text" placeholder="Username" v-model="user.username"> -->
                <div  class="p-3 bg-gray-150 w-full border border-gray-300 rounded-md tracking-normal">{{ user.username }}</div>
            </div>
            <div class="w-full flex space-x-3">
                <div class="w-full flex flex-col space-y-2">
                    <div>First Name:</div>
                    <!-- <input class="p-3 w-full bg-gray-150 border border-gray-300 rounded-md" required type="text" placeholder="First Name"  v-model="user.first_name"> -->
                    <div class="p-3 h-[46px] bg-gray-150 w-full border border-gray-300 rounded-md tracking-normal">{{ user.first_name }}</div>
                </div>
                <div class="w-full flex flex-col space-y-2">
                    <div>Last Name:</div>
                    <!-- <input class="p-3 w-full bg-gray-150 border border-gray-300 rounded-md" required type="text" placeholder="Last Name"  v-model="user.last_name"> -->
                    <div class="p-3 h-[46px] bg-gray-150 w-full border border-gray-300 rounded-md tracking-normal">{{ user.last_name }}</div>
                </div>
            </div>
            <div class="w-full flex flex-col space-y-2">
                <div class="">Groups:</div>
                <div class="flex flex-wrap capitalize px-3 py-2 min-h-[48px] bg-gray-150 w-full border border-gray-300 rounded-md">
                    <div v-for="userGroup in userGroups" :key="userGroup.id" class="py-1">{{ getGroupLabel(userGroup.name) }}</div>
                </div>
            </div>
            <div v-if="!retrievedUserImages" @click="getUserImages" class="p-4 bg-none flex w-full justify-between rounded-md border border-gray-300 text-gray-800 hover:underline hover:text-indigo-700 hover:bg-indigo-50 cursor-pointer">
                View Uploaded Images
            </div>
            <div v-else>
                <div class="">Uploaded Images ({{ userImages.length }})</div>
                <div class="flex flex-wrap space-x-2 w-full py-2">
                    <a v-for="userImage in userImages" :key="userImage.id" :href="userImage.pre_signed_image_url" target="_blank">
                        <img class="w-28 h-28 border border-gray-300 rounded-md object-cover" :src="userImage.pre_signed_image_url" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed } from 'vue';

const props = defineProps(['user', 'userImages', 'userGroups', 'retrievedUserImages'])
const emit = defineEmits('get-user-images')

function getGroupLabel(groupName) {
    return groupName.replace('_group', '').replace('_', ' ')
}

function getUserImages() {
    emit('get-user-images')
}
</script>